import React from 'react'
import { DetailReference, DetailType } from '~/types/state'
import RecipeInputNode from '../nodes/RecipeInputNode'
import RecipeTaskNode from '../nodes/RecipeTaskNode'

interface DetailCardIconProps {
  reference: DetailReference<DetailType>
}

const DetailCardIcon = ({ reference }: DetailCardIconProps): JSX.Element | null => {
  const { type } = reference

  switch (type) {
    case 'input': {
      const ref = reference as DetailReference<'input'>
      return <RecipeInputNode label="" position={[24, 20]} input={ref.input} />
    }
    case 'output': {
      // const ref = reference as DetailReference<'output'>
      return null
    }
    case 'task': {
      const ref = reference as DetailReference<'task'>
      return <RecipeTaskNode label="" position={[18, 19]} task={ref.task} />
    }
  }
}

export default DetailCardIcon
